module.exports = __webpack_public_path__ + "img/c11.37a8c198.png";